import React from 'react'
import Card from 'react-bootstrap/Card';
import { ReactComponent as SvgTools } from './lightbulb-fill.svg';
import { ReactComponent as SvgLight } from './tools.svg';
import { ReactComponent as SvgDroplet } from './droplet-half.svg';
import { ReactComponent as SvgFire } from './fire.svg';

export default function Servicios() {
    var CardContent = [
        {
            title: "Plomería",
            description: "Para hogares y comercios, incluyendo reparación de cañerías, instalación de grifería, desagües y sanitarios. También brindamos soluciones a problemas de filtraciones y pérdidas de agua para garantizar un sistema eficiente y sin inconvenientes."
        },
        {
            title: "Remodelación de ambientes",
            description: "Transformamos y optimizamos tus espacios con remodelaciones personalizadas. Desde renovación de baños y cocinas hasta la mejora de cualquier ambiente, trabajamos con materiales de calidad para lograr un resultado funcional y estético."
        },
        {
            title: "Electricidad",
            description: "Brindamos soluciones eléctricas para hogares y negocios. Instalamos y reparamos cableados, tableros eléctricos, iluminación, enchufes y disyuntores, asegurando instalaciones seguras y eficientes."
        },
        {
            title: "Gas",
            description: "Especialistas en instalaciones y reparaciones de gas. Realizamos la colocación de cañerías, conexión de artefactos, detección y reparación de fugas, siempre cumpliendo con las normativas de seguridad vigentes con nuestro personal matriculado."
        }
    ];

    return (
        <section className="px-2 py-4 text-center d-flex flex-wrap justify-content-center bg-light" style={{ minHeight: "50vh" }}>
            <Card style={{ width: "18rem", margin: "8px" }}>
                <div>
                    <SvgDroplet
                        variant="top"
                        className="text-center text-primary"
                        style={{
                            objectFit: 'cover',
                            width: '110px',
                            height: '110px',
                            marginTop: '24px',
                            marginBottom: '24px'
                        }} />
                </div>
                <Card.Body>
                    <Card.Title className="fw-bolder text-body-secondary">{CardContent[0].title}</Card.Title>
                    <Card.Text className="text-body-tertiary">
                        {CardContent[0].description}
                    </Card.Text>
                </Card.Body>
            </Card>

            <Card style={{ width: "18rem", margin: "8px" }}>
                <div>
                    <SvgLight
                        variant="top"
                        className="text-center text-secondary"
                        style={{
                            objectFit: 'cover',
                            width: '110px',
                            height: '110px',
                            marginTop: '24px',
                            marginBottom: '24px'
                        }} />
                </div>
                <Card.Body>
                    <Card.Title className="fw-bolder text-body-secondary">{CardContent[1].title}</Card.Title>
                    <Card.Text className="text-body-tertiary">
                        {CardContent[1].description}
                    </Card.Text>
                </Card.Body>
            </Card>

            <Card style={{ width: "18rem", margin: "8px" }}>
                <div>
                    <SvgTools
                        variant="top"
                        className="text-center text-warning"
                        style={{
                            objectFit: 'cover',
                            width: '110px',
                            height: '110px',
                            marginTop: '24px',
                            marginBottom: '24px'
                        }} />
                </div>
                <Card.Body>
                    <Card.Title className="fw-bolder text-body-secondary">{CardContent[2].title}</Card.Title>
                    <Card.Text className="text-body-tertiary">
                        {CardContent[2].description}
                    </Card.Text>
                </Card.Body>
            </Card>

            <Card style={{ width: "18rem", margin: "8px" }}>
                <div>
                    <SvgFire
                        variant="top"
                        className="text-center text-danger"
                        style={{
                            objectFit: 'cover',
                            width: '110px',
                            height: '110px',
                            marginTop: '24px',
                            marginBottom: '24px'
                        }} />
                </div>
                <Card.Body>
                    <Card.Title className="fw-bolder text-body-secondary">{CardContent[3].title}</Card.Title>
                    <Card.Text className="text-body-tertiary">
                        {CardContent[3].description}
                    </Card.Text>
                </Card.Body>
            </Card>
        </section>
    )
}
